import React from "react";
import Layout from "@components/layout";
import CityCard from "@components/countryPage/CityCard/cityCard";
import CountryDescription from "@components/countryPage/CountryDescription/countryDescription";
import SEO from "@components/seo";
import UniplacesFullContainer from "@components/UniplacesFullContainer/uniplacesFullContainer";
import FooterSection from "@components/countryPage/FooterSection/footerSection";

const CountryTemplate = ({
  data: {
    countryName: {
      0: { text: name },
    },
    countryCapitalCity: {
      0: { text: capitalCity },
    },
    countryCurrencySymbol: {
      0: { text: currencySymbol },
    },
    countryCurrencyCode: {
      0: { text: currencyCode },
    },
    countryCallingCode: {
      0: { text: callingCode },
    },
    countryFlag,
    countryDescription,
    countryImage: {
      url: countryImageUrl
    },
    countryFooter,
    countryCities,
  },
  pageContext: { locale },
}) => {
  const cards = countryCities.map(city => {
    if (city.countryCity !== null) {
      const {
        countryCity: {
          cityName: {
            0: { text: name },
          },
          cityImage,
          cityDescription,
          _meta: { uid: slug },
        },
      } = city;

      return (
        <CityCard
          name={name}
          cityImage={cityImage}
          cityDescription={cityDescription}
          slug={slug}
          key={slug}
          locale={locale}
        />
      );
    }

    return null;
  });

  return (
    <Layout locale={locale}>
      <SEO
        titleKey="seo.accommodation.title"
        description={`Uniplaces ${name}`}
        lang={locale}
        imageUrl={countryImageUrl}
      />
      <UniplacesFullContainer>
        <React.Fragment>
          <CountryDescription
            countryName={name}
            capitalCity={capitalCity}
            currencySymbol={currencySymbol}
            currencyCode={currencyCode}
            callingCode={callingCode}
            countryDescription={countryDescription}
            countryFlag={countryFlag}
            countryFooter={countryFooter}
          />
          {cards}
          <FooterSection locale={locale} />
        </React.Fragment>
      </UniplacesFullContainer>
    </Layout>
  );
};

export default CountryTemplate;
